import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryPay.js';
import { RichText } from '@synergycms_core/components/generic';
import Price from '@synergycms_core/components/generic/Price';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import AvailMainSideSummaryEquivalentPrice from './AvailMainSideSummaryEquivalentPrice';


const AvailMainSideSummaryPay = class AvailMainSideSummaryPay extends React.Component {
  static displayName = 'AvailMainSideSummaryPay';

  render() {
    const { config, theme } = this.props,
      {
        text,
        value,
        isEquivalent,
        showRight,
        forceSymbol,
        giftCodeDiscount,
        stepCode
      } = config;
    
    const { classes } = theme.styles;

    return (
      <div className={giftCodeDiscount || !showRight ? classes.contentModule : classes.extended}>
        <div className={[showRight && !giftCodeDiscount ? [classes.contentModuleRowReverse, classes.addPadding].join(' ') : ''].join(' ')}>
          <div className={[classes.contentModuleCell, classes.contentModuleCellTitle].join(' ')}>
            <RichText
              ucFirst={true}
              text={text}
              translate={true}
            />
          </div>
        </div>
        {!isEquivalent ? (
          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
          <Price
            innerStyle={['summaryPriceMedium', classes.contentModuleCellPrice].join(' ')}
            amount={value}
            forceHotelCurrency={stepCode === 'confirmation'}
            forceSymbol={forceSymbol}
          />
          </div>
        ) : (stepCode !== 'confirmation' &&
          <div className={[showRight ? [classes.contentModuleRowReverse, classes.addPaddingLarge].join(' ') : '']}>
            <AvailMainSideSummaryEquivalentPrice totalPrice={value} />
          </div>
        )}
      </div>
    )
  }
};

export default compose(
  PropertyManager([
    'value',
    'text',
    'isEquivalent',
    'showRight',
    'forceSymbol',
    'giftCodeDiscount',
    'stepCode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryPay);
